export enum FeatureFlags {
   TelenetPayment = 'TelenetPayment',
   TelenetPaymentFeedbackApiKey = 'TelenetPaymentFeedbackApiKey',
   TinaLocation = 'TinaLocation',
   EnableM365ArrowOrder = 'EnableM365ArrowOrder'
}
